import { h } from "preact";

function SliderNav({ activeSlideId, setActiveSlideId }) {
  console.log("SliderNav rendered");

  const activeClassName = "index__nav-item-active";
  const className = "index__nav-item";
  const tempData = [
    ["Компания", "«ЛЕГИС»"],
    ["Физическая", "охрана"],
    ["Пультовая", "охрана"],
    ["Тех. средства", "охраны"],
    ["Решения", "в сфере IT"],
    ["Юридические", "услуги"],
  ];

  const handleClick = (event, slideIndex) => {
    setActiveSlideId(slideIndex);
  };

  return (
    <div className="g-wrapper" id="index-slider-nav">
      <div className="index__nav slider3 reveal" data-sr-id="2">
        {tempData.map((item, i) => {
          const cn = `${className} ${
            activeSlideId === i ? activeClassName : ""
          }`;
          return (
            <button className={cn} onClick={(event) => handleClick(event, i)}>
              <span>
                {" "}
                {item[0]}
                <br />
                {item[1]}{" "}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { SliderNav };
